'use strict';

wbApp.directive('wbReferenceSourceCombo', ['$timeout', '$translate', 'referenceSourceSvc',
    function ($timeout, $translate, referenceSourceSvc) {

        var lookupData = { results: [] };

        function format(item) {
            if (item.id) return item.name;
        }

        referenceSourceSvc.getAllAsync().$promise
            .then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    lookupData.results.push(data[i]);
                }
            });

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_REFERENCE_SOURCE'),
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        formatResult: format,
                        formatSelection: format,
                        data: lookupData
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });
                }, 1);
            }
        }
    }]);


